import axios from 'axios';

/** The backend's answer to a signed-in person who is not (or no longer) an
 *  active FinOps user. Must match user_access.NOT_AUTHORIZED exactly. */
export const NOT_AUTHORIZED = 'Your account is not authorized to use Eyvo FinOps.';

/** The backend's answer to an active FinOps user who holds no permission.
 *  Must match user_access.NO_ACCESS_ASSIGNED exactly. */
export const NO_ACCESS_ASSIGNED = 'You are signed in, but no FinOps access has been assigned to your account. Please contact a FinOps administrator.';

/** Fired when the backend says this user's access has changed under them.
 *  AuthContext re-reads /api/auth/me, and the app redraws from the answer. */
export const ACCESS_CHANGED_EVENT = 'finops:access-changed';

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true,
});

const toLogin = (query = '') => {
  // Never from /login itself: that page loads /api/auth/me too, and
  // redirecting it to itself would loop.
  if (!window.location.pathname.includes('/login')) {
    window.location.href = `/login${query}`;
  }
};

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    if (status === 401) {
      toLogin();
    } else if (status === 403 && error.response?.data?.detail === NOT_AUTHORIZED) {
      // Access revoked mid-session. Any other 403 is an ordinary permission
      // refusal and stays with the page that asked.
      toLogin('?auth_error=not_authorized');
    } else if (status === 403 && error.response?.data?.detail === NO_ACCESS_ASSIGNED) {
      // Their last permission was removed mid-session. Still signed in, so no
      // trip to /login (it would only send them back): re-read who they are,
      // and the app replaces itself with the no-access screen.
      window.dispatchEvent(new Event(ACCESS_CHANGED_EVENT));
    }
    return Promise.reject(error);
  }
);

export default api;
